import { render, staticRenderFns } from "./Original.vue?vue&type=template&id=e107b9e2&scoped=true&"
import script from "./Original.vue?vue&type=script&lang=js&"
export * from "./Original.vue?vue&type=script&lang=js&"
import style0 from "./Original.vue?vue&type=style&index=0&id=e107b9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e107b9e2",
  null
  
)

export default component.exports